<template>
  <div class="col">
    <div class="card">
      <div class="card-body text-center">
        <h1 class="card-text">{{ body }}</h1>
      </div>
      <div class="card-footer text-center">
          <h5>{{ footer }}</h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props:{
    body: String,
    footer: String,
  },
}

</script>
